import Axios from 'axios';
import Helper from "./helper";
import Cookie from "./cookie";
const Config = require('../config/config');

class request {
    constructor() {
        this.token = Helper.getToken();
        let headers = {};
        if (this.token) {
            headers[Config.userLoginAccessTokenKey] = this.token;
        }
        this.axios = Axios.create({
            timeout: 1000 * 60,
            responseType: 'json',
            baseURL: Config.apiBaseUrl,
            headers: headers
        });

        this.cdcToken = Helper.getUdcToken();
        let uheaders = {};
        if (this.cdcToken) {
            uheaders['oasis-core-token'] = this.cdcToken;
        }

        this.uaxios = Axios.create({
            timeout: 1000 * 60,
            responseType: 'json',
            baseURL: Config.udcApiBaseUrl,
            headers: uheaders
        });
    }

    isNeedGameCode(data) {
        let isCode = data['isGameCode'] !== undefined ? data['isGameCode'] : true;
        if (isCode) {
            data = Object.assign(Helper.getGameCode(), data);
        }
        return data;
    }

    /***
     *
     * @param ajaxOtions
     * @returns {[]}
     * @private
     */
    __getAjaxArrFn(ajaxOtions) {
        let temp = [];
        let len = ajaxOtions.length;
        for (let i = 0; i < len; i++) {
            let fn;
            if (ajaxOtions[i]['method'] === 'get') {
                fn = () => {
                    let url = this.replaceGameCode(ajaxOtions[i]['url']);
                    return this.get(url, ajaxOtions[i]['data'], ajaxOtions[i]['header']);
                };
            }
            if (ajaxOtions[i]['method'] === 'post') {
                let isFormData = ajaxOtions[i]['isFormData'] === undefined ? true : ajaxOtions[i]['isFormData'];
                fn = () => {
                    let url = this.replaceGameCode(ajaxOtions[i]['url']);
                    return this.post(url, ajaxOtions[i]['data'], ajaxOtions[i]['header'], isFormData);
                };
            }
            temp.push(fn());
        }
        return temp;
    }

    /**
     * ajax get request
     * @param url
     * @param data
     * @param header
     * @returns {AxiosPromise}
     */
    get(url, data = {}, header = {}) {
        url = this.replaceGameCode(url);
        data = this.isNeedGameCode(data);
        return this.axios({
            url: url,
            method: 'get',
            params: data,
        });
    }

    /**
     * 替换url中有{game_code}字符串
     * @param url
     * @returns {*}
     */
    replaceGameCode(url) {
        // let code = Cookie.get('odp-selectedGameCode');
        let code = Helper.getGameCode().game_code;
        if (!url && Config.isDebug) {
            alert('请检查你的配置（../website/config）中的API地址是否已配置');
            return;
        }

        if (url.indexOf('{game_code}') !== -1) {
            url = url.replace(/\{game_code\}/g, code);
        }
        return url;
    }

    /**
     * ajax put request
     * @param url
     * @param data
     * @param header
     * @returns {AxiosPromise}
     */
    put(url, data = {}, header = {}) {
        url = this.replaceGameCode(url);
        data = this.isNeedGameCode(data);
        return this.axios({
            url: url,
            method: 'put',
            data: data,
        });
    }

    /**
     * ajax delete request
     * @param url
     * @param data
     * @param header
     * @returns {AxiosPromise}
     */
    delete(url, data = {}, header = {}) {
        url = this.replaceGameCode(url);
        data = this.isNeedGameCode(data);
        return this.axios({
            url: url,
            method: 'delete',
            data: data,
        });
    }

    /**
     * ajax post request
     * @param url
     * @param data
     * @param header
     * @param isFormData
     * @returns {AxiosPromise}
     */
    post(url, data = {}, header = {}, isFormData = false) {
        url = this.replaceGameCode(url);
        data = this.isNeedGameCode(data);

        /** 使用FormData格式**/
        if (isFormData) {
            header['Content-Type'] = 'application/x-www-form-urlencoded';
            data = Helper.paramJSON(data);
        }

        return this.axios({
            url: url,
            method: 'post',
            headers: header,
            data: data
        });
    }

    filePost(url, data = {}, header = {}) {
        url = this.replaceGameCode(url);
        header['Content-Type'] = 'application/x-www-form-urlencoded';
        console.log(data);
        return this.axios({
            url: url,
            method: 'post',
            headers: header,
            data: data
        });
    }

    /**
     * 一次请求多个接口方法
     * @param ajaxOtions [
     *      {url: url, data: {},header:{},method:'get', key: 'key1'},
     *      {url: url, data: {},header:{},method:'post',isFormData: false, key: 'key1'}
     * ]
     * @param callback;
     * @param errorCallback
     */
    all(ajaxOtions = [], callback, errorCallback) {
        if (ajaxOtions.length === 0) {
            console.error('Param is not empty');
            return;
        }
        Axios.all(this.__getAjaxArrFn(ajaxOtions))
            .then(Axios.spread(function (...values) {
                let len = values.length;
                let data = {};
                for (let i = 0; i < len; i++) {
                    if (ajaxOtions[i]['key']) {
                        data[ajaxOtions[i]['key']] = values[i];
                    }
                    else {
                        data[i] = values[i];
                    }
                }
                callback(data);
            })).catch((res) => {
                errorCallback(res);
            });
    }

    /** udc项目请求**/
    upost(url, data = {}, header) {
        data = Object.assign({}, { gamecode: Helper.getGameCode().game_code }, data);
        let params = new FormData();
        for (let key in data) {
            params.append(key, data[key]);
        }
        params = new URLSearchParams(params);
        return this.uaxios({
            url: url,
            method: 'post',
            data: params
        });
    }
};

export default new request();



// WEBPACK FOOTER //
// ./website/helper/request.js